export default __webpack_public_path__ + "static/media/telefone.5118c070.svg";